// Textos de la zona "rack". Claves con prefijo "rack." (common: sin prefijo fijo).
//
//  rack.effect.<typeId>.name   nombre de cada efecto del registro (effectRegistry.js)
//  rack.category.<id>          familia del efecto; rack.category.<id>.desc = qué es
const en = {
  // ── Nombres de los efectos (los usan también los paneles y MusicPlayer) ──
  'rack.effect.player.name': 'Audio player',
  'rack.effect.eq.name': '9-band EQ',
  'rack.effect.corrector.name': 'Corrector (headphones/speakers)',
  'rack.effect.reverb.name': 'Reverb',
  'rack.effect.comp.name': 'Compressor',
  'rack.effect.stereo.name': 'Stereo',
  'rack.effect.dist.name': 'Distortion (multiband)',
  'rack.effect.crush.name': 'Bitcrusher (Lo-Fi)',
  'rack.effect.gate.name': 'Noise Gate',
  'rack.effect.nuevos.name': 'New effects (Lǜ · Wǔxíng)',
  'rack.effect.rider.name': 'Auto-Leveler',
  'rack.effect.rec.name': 'Recorder',
  'rack.effect.gain.name': 'Gain (volume)',

  // ── Familias ──
  'rack.category.dynamics': 'Dynamics',
  'rack.category.eq': 'Equalization',
  'rack.category.space': 'Space',
  'rack.category.experimental': 'Experimental',
  'rack.category.stereo': 'Stereo image',
  'rack.category.lofi': 'Lo-Fi',
  'rack.category.saturation': 'Saturation',
  'rack.category.utility': 'Utility',
  'rack.category.dynamics.desc': 'Tame the volume: even it out, hold back the peaks or silence background noise.',
  'rack.category.eq.desc': 'Boost or cut bass, mids and treble. It is the overall tone.',
  'rack.category.space.desc': 'Simulate a room, so the sound does not feel glued to your ear.',
  'rack.category.experimental.desc': 'The odd ones: effects to try out and play with.',
  'rack.category.stereo.desc': 'Place the sound between the left and right sides.',
  'rack.category.lofi.desc': 'Dirty the sound on purpose: old radio, 8-bit console.',
  'rack.category.saturation.desc': 'Warm up and break up the sound, like an amp cranked all the way.',
  'rack.category.utility.desc': 'They do not change the tone: they play your audio, record or adjust the volume.',

  // ── Tarjeta del rack (RackSlot) ──
  'rack.slot.led.on': 'On: this effect is active',
  'rack.slot.led.mute': 'Muted: this effect is bypassed',
  'rack.slot.led.off': 'Off: another effect is soloed',
  'rack.slot.clear': 'Clear slot',
  'rack.slot.clearTitle': 'Clear slot (the signal passes through unchanged)',
  'rack.slot.emptyNumTitle': 'Space {n}: the signal passes through here in position {n}',
  'rack.slot.numTitle': 'Slot {n}: the signal passes through here in position {n}',
  'rack.slot.emptyTitle': 'Empty slot',
  'rack.slot.emptyHint': 'Click to choose an effect, or drag one here from the catalog. Empty, the sound passes through unchanged.',
  'rack.slot.emptyHintPhone': 'Tap to choose an effect. Empty, the sound passes through unchanged.',
  'rack.slot.handleTitle': 'Drag to move it to another slot (the signal follows the order) or drop it on the catalog to remove it',
  'rack.slot.addEffect': '+ Add effect',
  'rack.slot.replaceTitle': 'Replace the effect in slot {n}',
  'rack.slot.placeTitle': 'Place in slot {n}',
  'rack.slot.enterReplace': 'Enter → replaces slot {n}',
  'rack.slot.enterPlace': 'Enter → slot {n}',
  'rack.slot.slotN': 'Slot {n}',

  // ── Catálogo (EffectBrowser) ──
  'rack.browser.title': 'Catalog',
  'rack.browser.trashOver': 'Release to remove it from the rack',
  'rack.browser.trashHint': 'Drop it here to remove it from the rack',
  'rack.browser.armedPick': 'Pick the slot with',
  'rack.browser.armedKeys': 'or keys',
  'rack.browser.armedMouse': '(or click it)',
  'rack.browser.armedConfirm': 'and confirm with',
  'rack.browser.armedCancel': 'Cancel (Escape)',
  'rack.browser.searchPlaceholder': 'Search effects…',
  'rack.browser.searchLabel': 'Search the effect catalog',
  'rack.browser.filterLabel': 'Filter by effect family',
  'rack.browser.allTitle': 'Show the full catalog',
  'rack.browser.all': 'All',
  'rack.browser.full': 'Rack full ({n}/{n}). Drag an effect onto the slot you want to replace, or clear one with',
  'rack.browser.placeTitle': 'Place {name} in a specific slot (or drag the card onto it)',
  'rack.browser.inUse': 'Already {n} in the rack',
  'rack.browser.addTitle': 'Add {name} to slot {n} (the first free one)',
  'rack.browser.addFullTitle': 'The rack is full: drag the effect onto the slot you want to replace',
  'rack.browser.noResults': 'Nothing for «{q}».',
  'rack.browser.showAll': 'Show all',
  'rack.browser.footDrag': 'Drag',
  'rack.browser.footRest': 'a card to the slot you want, or click it to pick one with the keyboard.',
  'rack.browser.footPlusA': 'The',
  'rack.browser.footPlusB': 'sends it straight to',
  'rack.browser.footSlot': 'slot {n}',

  // ── Arrastrar y soltar (RackDnd) ──
  'rack.dnd.slot': 'Slot {n}',
  'rack.dnd.back': 'Back to its place',
  'rack.dnd.swap': 'Swap with slot {n}',
  'rack.dnd.move': 'Move to slot {n}',
  'rack.dnd.replace': 'Replace slot {n}',
  'rack.dnd.remove': 'Remove from rack',
  'rack.dnd.dropHint': 'Drop on a slot',
  'rack.dnd.srPlacingBusy': 'Placing in {target}, occupied: it will be replaced. Enter to confirm, Escape to cancel.',
  'rack.dnd.srPlacingEmpty': 'Placing in {target}, empty. Enter to confirm, Escape to cancel.',

  // ── Mandos comunes (controls.js) ──
  'rack.controls.soloTitle': 'Solo: hear only this effect (bypasses the others)',
  'rack.controls.muteTitle': 'Mute: bypass this effect',
  'rack.controls.howItWorks': 'How does it work?',
  'rack.controls.explainHide': 'Hide the explanation',
  'rack.controls.explainShow': 'Show a short explanation',
  'rack.controls.knobTitle': '{label} — drag vertically or use the wheel · double-click = {v}',
  'rack.controls.resetTo': 'Reset to {v}',
  'rack.controls.resetLabel': 'Reset {label} to {v}',

  // ── Barra del rack (RackToolbar) ──
  'rack.toolbar.config': 'My setup',
  'rack.toolbar.prev': 'Previous setup',
  'rack.toolbar.next': 'Next setup',
  'rack.toolbar.pickTitle': 'Choose a saved setup',
  'rack.toolbar.default': 'Default',
  'rack.toolbar.unsavedPick': 'Unsaved — pick one',
  'rack.toolbar.unsaved': 'Unsaved',
  'rack.toolbar.defaultTitle': 'Factory settings: empty rack, no profile, normal volume',
  'rack.toolbar.defaultSub': 'Start from scratch: empty rack',
  'rack.toolbar.noConfigs': 'Nothing saved yet. Tweak the sound and press',
  'rack.toolbar.save': 'Save',
  'rack.toolbar.rename': 'Rename',
  'rack.toolbar.applyTitle': 'Load "{name}"',
  'rack.toolbar.renameTitle': 'Rename "{name}"',
  'rack.toolbar.deleteTitle': 'Delete "{name}"',
  'rack.toolbar.saveTitle': 'Save the current sound',
  'rack.toolbar.saveNoteA': 'Saves',
  'rack.toolbar.saveNoteB': 'everything',
  'rack.toolbar.saveNoteC': 'you hear now: the rack effects, their order, the output volume and your device.',
  'rack.toolbar.saveChanges': 'Save changes to «{name}»',
  'rack.toolbar.saveAsNew': 'Or save as new',
  'rack.toolbar.name': 'Name',
  'rack.toolbar.namePlaceholder': 'E.g. Headphones · Rock',
  'rack.toolbar.revertTitle': 'Go back to «{name}» as it was saved',
  'rack.toolbar.revertDefault': 'Go back to Default (empty rack)',
  'rack.toolbar.revertNone': 'Load a setup to be able to go back to it',
  'rack.toolbar.device': 'My device',
  'rack.toolbar.deviceTitle': 'Choose the calibrated headphones or speaker',
  'rack.toolbar.noProfile': 'No profile (flat)',
  'rack.toolbar.noDevicesA': 'No devices yet. Press',
  'rack.toolbar.recalibrate': 'Recalibrate',
  'rack.toolbar.noDevicesB': ', take the test and save it: the EQ will adapt to your headphones or speakers.',
  'rack.toolbar.profileTitle': 'Fit the EQ to "{name}"',
  'rack.toolbar.clearProfile': 'Remove profile (flat EQ)',
  'rack.toolbar.bypassOn': 'Effects off: click to turn them on',
  'rack.toolbar.bypassOff': 'Turn off all effects to compare with the original sound',
  'rack.toolbar.templates': 'DragonAudio templates',
  'rack.toolbar.mine': 'My setups',
  'rack.toolbar.edited': '(edited)',
  'rack.toolbar.restoreTitle': 'Restore «{name}» to the original template',
  'rack.toolbar.bypass': 'Bypass',

  // ── Motor de audio: captura, reproductor, grabadora, formatos ──
  'rack.capture.unsupported': 'This browser does not support audio capture (missing {method}). Try an up-to-date Chrome, Edge or Opera.',
  'rack.capture.insecure': 'Audio capture needs a secure connection. You are on {origin}, and the browser only allows it on https:// or http://localhost. Open the app at http://localhost:3000 (or set up HTTPS on the server) and try again.',
  'rack.capture.noTabAudio': 'No audio was shared',
  'rack.capture.noMic': 'No microphone detected',
  'rack.player.tooMany': 'The player holds up to {max} audio files at once. Remove one to add another.',
  'rack.player.linkLost': 'The link to the server was lost. Remove it and load it again from "My saved tracks".',
  'rack.player.unreadable': 'This browser could not read the file. Try converting it to MP3.',
  'rack.player.blocked': 'The browser blocked playback. Press ▶ again.',
  'rack.recorder.mp3LoadFailed': 'Could not load the MP3 encoder. Check your connection or record in WAV.',
  'rack.format.wav16.label': '16-bit WAV',
  'rack.format.wav16.hint': 'Lossless, CD quality. The recommended option.',
  'rack.format.wav24.label': '24-bit WAV',
  'rack.format.wav24.hint': 'Lossless with extra headroom. 50% bigger, and the difference is rarely audible.',
  'rack.format.mp3-320.label': 'MP3 320 kbps',
  'rack.format.mp3-320.hint': 'Highest-quality compression: 5 times lighter than WAV.',
  'rack.format.mp3-256.label': 'MP3 256 kbps',
  'rack.format.mp3-256.hint': 'Very good quality in less space.',
  'rack.format.mp3-192.label': 'MP3 192 kbps',
  'rack.format.mp3-192.hint': 'The lightest. Good enough for voice and work notes.',
};

const es = {
  // ── Nombres de los efectos (los usan también los paneles y MusicPlayer) ──
  'rack.effect.player.name': 'Reproductor de audios',
  'rack.effect.eq.name': 'EQ 9 bandas',
  'rack.effect.corrector.name': 'Corrector (audífonos/parlantes)',
  'rack.effect.reverb.name': 'Reverb',
  'rack.effect.comp.name': 'Compresor',
  'rack.effect.stereo.name': 'Estéreo',
  'rack.effect.dist.name': 'Distorsión (multibanda)',
  'rack.effect.crush.name': 'Bitcrusher (Lo-Fi)',
  'rack.effect.gate.name': 'Noise Gate',
  'rack.effect.nuevos.name': 'Nuevos efectos (Lǜ · Wǔxíng)',
  'rack.effect.rider.name': 'Auto-Nivelador',
  'rack.effect.rec.name': 'Grabadora',
  'rack.effect.gain.name': 'Ganancia (volumen)',

  // ── Familias ──
  'rack.category.dynamics': 'Dinámica',
  'rack.category.eq': 'Ecualización',
  'rack.category.space': 'Espacio',
  'rack.category.experimental': 'Experimental',
  'rack.category.stereo': 'Imagen estéreo',
  'rack.category.lofi': 'Lo-Fi',
  'rack.category.saturation': 'Saturación',
  'rack.category.utility': 'Utilidad',
  'rack.category.dynamics.desc': 'Domestican el volumen: lo emparejan, sujetan los picos o callan el ruido de fondo.',
  'rack.category.eq.desc': 'Suben o bajan graves, medios y agudos. Es el tono general.',
  'rack.category.space.desc': 'Simulan una sala, para que el sonido no suene pegado al oído.',
  'rack.category.experimental.desc': 'Lo raro de la casa: efectos para probar y jugar.',
  'rack.category.stereo.desc': 'Colocan el sonido entre el lado izquierdo y el derecho.',
  'rack.category.lofi.desc': 'Ensucian el sonido a propósito: radio vieja, consola de 8 bits.',
  'rack.category.saturation.desc': 'Calientan y rompen el sonido, como un amplificador a tope.',
  'rack.category.utility.desc': 'No cambian el tono: sirven para poner tus audios, grabar o ajustar el volumen.',

  // ── Tarjeta del rack (RackSlot) ──
  'rack.slot.led.on': 'Encendido: este efecto está sonando',
  'rack.slot.led.mute': 'En Mute: este efecto no se aplica',
  'rack.slot.led.off': 'Apagado: otro efecto está en Solo',
  'rack.slot.clear': 'Vaciar slot',
  'rack.slot.clearTitle': 'Vaciar slot (la señal pasa sin cambios)',
  'rack.slot.emptyNumTitle': 'Espacio {n}: la señal pasa por aquí en {n}º lugar',
  'rack.slot.numTitle': 'Slot {n}: la señal pasa por aquí en {n}º lugar',
  'rack.slot.emptyTitle': 'Espacio libre',
  'rack.slot.emptyHint': 'Pulsa para elegir un efecto, o arrastra uno del catálogo hasta aquí. Vacío, el sonido pasa sin cambios.',
  'rack.slot.emptyHintPhone': 'Toca para elegir un efecto. Vacío, el sonido pasa sin cambios.',
  'rack.slot.handleTitle': 'Arrastra para moverlo de slot (la señal sigue el orden) o suéltalo sobre el catálogo para quitarlo',
  'rack.slot.addEffect': '+ Añadir efecto',
  'rack.slot.replaceTitle': 'Sustituir el efecto del slot {n}',
  'rack.slot.placeTitle': 'Colocar en el slot {n}',
  'rack.slot.enterReplace': 'Enter → sustituye el slot {n}',
  'rack.slot.enterPlace': 'Enter → slot {n}',
  'rack.slot.slotN': 'Slot {n}',

  // ── Catálogo (EffectBrowser) ──
  'rack.browser.title': 'Catálogo',
  'rack.browser.trashOver': 'Suelta para quitarlo del rack',
  'rack.browser.trashHint': 'Suéltalo aquí para quitarlo del rack',
  'rack.browser.armedPick': 'Elige el slot con',
  'rack.browser.armedKeys': 'o las teclas',
  'rack.browser.armedMouse': '(o púlsalo con el ratón)',
  'rack.browser.armedConfirm': 'y confirma con',
  'rack.browser.armedCancel': 'Cancelar (Escape)',
  'rack.browser.searchPlaceholder': 'Buscar efecto…',
  'rack.browser.searchLabel': 'Buscar efecto en el catálogo',
  'rack.browser.filterLabel': 'Filtrar por familia de efecto',
  'rack.browser.allTitle': 'Ver el catálogo completo',
  'rack.browser.all': 'Todos',
  'rack.browser.full': 'Rack lleno ({n}/{n}). Arrastra un efecto sobre el slot que quieras sustituir, o vacía uno con',
  'rack.browser.placeTitle': 'Colocar {name} en un slot concreto (o arrastra la tarjeta hasta él)',
  'rack.browser.inUse': 'Ya hay {n} en el rack',
  'rack.browser.addTitle': 'Añadir {name} al slot {n} (el primero libre)',
  'rack.browser.addFullTitle': 'El rack está lleno: arrastra el efecto sobre el slot que quieras sustituir',
  'rack.browser.noResults': 'Nada con «{q}».',
  'rack.browser.showAll': 'Ver todos',
  'rack.browser.footDrag': 'Arrastra',
  'rack.browser.footRest': 'una tarjeta al slot que quieras, o púlsala para elegirlo con el teclado.',
  'rack.browser.footPlusA': 'El',
  'rack.browser.footPlusB': 'lo manda directo al',
  'rack.browser.footSlot': 'slot {n}',

  // ── Arrastrar y soltar (RackDnd) ──
  'rack.dnd.slot': 'Slot {n}',
  'rack.dnd.back': 'Vuelve a su sitio',
  'rack.dnd.swap': 'Intercambia con el slot {n}',
  'rack.dnd.move': 'Mueve al slot {n}',
  'rack.dnd.replace': 'Sustituye el slot {n}',
  'rack.dnd.remove': 'Quitar del rack',
  'rack.dnd.dropHint': 'Suelta sobre un slot',
  'rack.dnd.srPlacingBusy': 'Colocando en {target}, ocupado: se sustituye. Enter para confirmar, Escape para cancelar.',
  'rack.dnd.srPlacingEmpty': 'Colocando en {target}, vacío. Enter para confirmar, Escape para cancelar.',

  // ── Mandos comunes (controls.js) ──
  'rack.controls.soloTitle': 'Solo: escucha únicamente este efecto (omite los demás)',
  'rack.controls.muteTitle': 'Mute: omite este efecto',
  'rack.controls.howItWorks': '¿Cómo funciona?',
  'rack.controls.explainHide': 'Ocultar la explicación',
  'rack.controls.explainShow': 'Ver una explicación corta',
  'rack.controls.knobTitle': '{label} — arrastra vertical o usa la rueda · doble clic = {v}',
  'rack.controls.resetTo': 'Restablecer a {v}',
  'rack.controls.resetLabel': 'Restablecer {label} a {v}',

  // ── Barra del rack (RackToolbar) ──
  'rack.toolbar.config': 'Mi configuración',
  'rack.toolbar.prev': 'Configuración anterior',
  'rack.toolbar.next': 'Configuración siguiente',
  'rack.toolbar.pickTitle': 'Elegir una configuración guardada',
  'rack.toolbar.default': 'Default',
  'rack.toolbar.unsavedPick': 'Sin guardar — elige una',
  'rack.toolbar.unsaved': 'Sin guardar',
  'rack.toolbar.defaultTitle': 'Todo como viene de fábrica: rack vacío, sin perfil, volumen normal',
  'rack.toolbar.defaultSub': 'Empezar de cero: rack vacío',
  'rack.toolbar.noConfigs': 'Aún no has guardado nada. Ajusta el sonido y pulsa',
  'rack.toolbar.save': 'Guardar',
  'rack.toolbar.rename': 'Renombrar',
  'rack.toolbar.applyTitle': 'Poner "{name}"',
  'rack.toolbar.renameTitle': 'Renombrar "{name}"',
  'rack.toolbar.deleteTitle': 'Borrar "{name}"',
  'rack.toolbar.saveTitle': 'Guardar el sonido actual',
  'rack.toolbar.saveNoteA': 'Guarda',
  'rack.toolbar.saveNoteB': 'todo',
  'rack.toolbar.saveNoteC': 'lo que suena ahora: los efectos del rack, su orden, el volumen de salida y tu dispositivo.',
  'rack.toolbar.saveChanges': 'Guardar cambios en «{name}»',
  'rack.toolbar.saveAsNew': 'O guardar como nueva',
  'rack.toolbar.name': 'Nombre',
  'rack.toolbar.namePlaceholder': 'Ej. Audífonos · Rock',
  'rack.toolbar.revertTitle': 'Volver a «{name}» tal como se guardó',
  'rack.toolbar.revertDefault': 'Volver a Default (rack vacío)',
  'rack.toolbar.revertNone': 'Pon una configuración para poder volver a ella',
  'rack.toolbar.device': 'Mi dispositivo',
  'rack.toolbar.deviceTitle': 'Elegir el audífono o parlante calibrado',
  'rack.toolbar.noProfile': 'Sin perfil (plano)',
  'rack.toolbar.noDevicesA': 'Aún no tienes dispositivos. Pulsa',
  'rack.toolbar.recalibrate': 'Recalibrar',
  'rack.toolbar.noDevicesB': ', haz el test y guárdalo: el EQ se ajustará a tus audífonos o parlantes.',
  'rack.toolbar.profileTitle': 'Ajustar el EQ a "{name}"',
  'rack.toolbar.clearProfile': 'Quitar perfil (EQ plano)',
  'rack.toolbar.bypassOn': 'Efectos apagados: pulsa para encenderlos',
  'rack.toolbar.bypassOff': 'Apaga todos los efectos para comparar con el sonido original',
  'rack.toolbar.templates': 'Plantillas DragonAudio',
  'rack.toolbar.mine': 'Mis configuraciones',
  'rack.toolbar.edited': '(editada)',
  'rack.toolbar.restoreTitle': 'Restaurar «{name}» a la plantilla original',
  'rack.toolbar.bypass': 'Bypass',

  // ── Motor de audio: captura, reproductor, grabadora, formatos ──
  'rack.capture.unsupported': 'Este navegador no soporta la captura de audio (falta {method}). Prueba con Chrome, Edge u Opera actualizados.',
  'rack.capture.insecure': 'La captura de audio necesita una conexión segura. Estás en {origin}, y el navegador solo la habilita en https:// o en http://localhost. Abre la app en http://localhost:3000 (o pon HTTPS en el servidor) y vuelve a intentarlo.',
  'rack.capture.noTabAudio': 'No se compartió audio',
  'rack.capture.noMic': 'No se detectó micrófono',
  'rack.player.tooMany': 'El reproductor admite {max} audios a la vez. Quita alguno para añadir otro.',
  'rack.player.linkLost': 'Se perdió el enlace con el servidor. Quítala y vuelve a cargarla desde "Mis pistas guardadas".',
  'rack.player.unreadable': 'Este navegador no pudo leer el archivo. Prueba a convertirlo a MP3.',
  'rack.player.blocked': 'El navegador bloqueó la reproducción. Vuelve a pulsar ▶.',
  'rack.recorder.mp3LoadFailed': 'No se pudo cargar el codificador de MP3. Revisa tu conexión o graba en WAV.',
  'rack.format.wav16.label': 'WAV 16 bits',
  'rack.format.wav16.hint': 'Sin pérdida, calidad de CD. La opción recomendada.',
  'rack.format.wav24.label': 'WAV 24 bits',
  'rack.format.wav24.hint': 'Sin pérdida con margen extra. Pesa 50 % más y la diferencia casi nunca se oye.',
  'rack.format.mp3-320.label': 'MP3 320 kbps',
  'rack.format.mp3-320.hint': 'Comprimido de máxima calidad: 5 veces más liviano que el WAV.',
  'rack.format.mp3-256.label': 'MP3 256 kbps',
  'rack.format.mp3-256.hint': 'Muy buena calidad ocupando menos.',
  'rack.format.mp3-192.label': 'MP3 192 kbps',
  'rack.format.mp3-192.hint': 'El más liviano. Suficiente para voz y notas de trabajo.',
};

const rack = { en, es };
export default rack;
